import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ElasticQuery } from 'app/interfaces/elastic-query.model';
import { QueryType } from 'app/enums/query-type.enum';

@Component({
  selector: 'app-aggregation-slider',
  templateUrl: './aggregation-slider.component.html',
  styleUrls: ['./aggregation-slider.component.scss'],
})
export class AggregationSliderComponent implements OnInit {
  @Input() aggregation: any;
  @Output() onChange: EventEmitter<ElasticQuery> = new EventEmitter<ElasticQuery>();
  @Input() expanded = true;

  minValue = 0;
  maxValue = 0;
  constructor() {}

  ngOnInit() {
    this.maxValue = this.aggregation.Value;
    //this.valueChanged();
    if (this.aggregation.selectedValues?.length) {
      this.minValue = parseInt(this.aggregation.selectedValues[0]);
      this.maxValue = parseInt(this.aggregation.selectedValues[1]);
    }
  }

  valueChanged() {
    this.onChange.emit({
      Field: this.aggregation.Meta.title,
      Type: QueryType.DROPDOWN,
      Values: [this.minValue || 0, this.maxValue || 0],
    });
  }
}
